<template>
  <el-row class="warp">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }"><b>首页</b></el-breadcrumb-item>
        <el-breadcrumb-item>项目管理</el-breadcrumb-item>
        <el-breadcrumb-item>项目列表</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>

    <el-col :span="24" class="warp-main">
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-form :inline="true" :model="filters" ref="filtersForm">
          <el-form-item label="项目名称" prop="name">
            <el-input
              v-model.trim="filters.name"
              placeholder="项目名称"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button type="primary" @click="resetForm('filtersForm')"
              >重置</el-button
            >
            <el-button
              type="primary"
              @click="showAddDialog"
              v-has-permission="'project:add'"
              >新增</el-button
            >
          </el-form-item>
        </el-form>
      </el-col>
      <!--列表-->
      <el-table
        :data="projectPageDatas"
        highlight-current-row
        border
        style="width: 100%"
      >
        <el-table-column
          type="index"
          width="60"
          align="center"
          fixed="left"
        ></el-table-column>
        <el-table-column
          prop="name"
          label="项目名称"
          width="180"
          show-overflow-tooltip
          fixed="left"
          sortable
        ></el-table-column>
        <el-table-column
          prop="id"
          label="项目ID"
          width="180"
          show-overflow-tooltip
          fixed="left"
          sortable
        ></el-table-column>
        <el-table-column
          prop="custName"
          label="客户名称"
          width="180"
          show-overflow-tooltip
          sortable
        ></el-table-column>
        <el-table-column
          prop="contact"
          label="联系人"
          width="100"
          sortable
        ></el-table-column>
        <el-table-column
          prop="telephone"
          label="联系电话"
          width="110"
          sortable
        ></el-table-column>
        <el-table-column
          prop="provinceName"
          label="省"
          width="100"
          sortable
        ></el-table-column>
        <el-table-column
          prop="cityName"
          label="市"
          width="100"
          sortable
        ></el-table-column>
        <el-table-column
          prop="districtName"
          label="区/县"
          width="100"
          sortable
        ></el-table-column>
        <el-table-column
          prop="addressDetail"
          label="详细地址"
          width="230"
          show-overflow-tooltip
          sortable
        ></el-table-column>
        <el-table-column
          prop="createDate"
          label="创建时间"
          width="155"
          sortable
        ></el-table-column>
        <el-table-column
          prop="updateDate"
          label="更新时间"
          width="155"
          sortable
        ></el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="260">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              @click="showEditDialog(scope.$index, scope.row)"
              v-has-permission="'project:update'"
              >编辑</el-button
            >
            <el-button
              type="primary"
              size="mini"
              @click="toDetail(scope.row)"
              v-has-permission="'project:detail'"
              >详情</el-button
            >
            <el-button
              type="danger"
              size="mini"
              @click="remove(scope.$index, scope.row)"
              v-has-permission="'project:delete'"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!--分页工具栏-->
      <el-col :span="24" class="toolbar">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="10"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="float: right"
        >
        </el-pagination>
      </el-col>

      <!--新增界面-->
      <el-dialog
        title="新增"
        :visible.sync="addFormVisible"
        @open="onAddDialogOpen"
        :close-on-click-modal="false"
      >
        <el-form
          :model="addForm"
          label-width="130px"
          :rules="formRules"
          ref="addForm"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="项目名称" prop="name">
                <el-input
                  v-model.trim="addForm.name"
                  placeholder="请输入内容"
                  maxlength="30"
                  show-word-limit
                  auto-complete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="客户名称" prop="orgId">
                <el-select
                  v-model="addForm.orgId"
                  filterable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in custDatas"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="2">
            <el-form-item label="省市区" required>
              <el-col :span="7">
                <el-form-item prop="provinceCode">
                  <el-select
                    v-model="addForm.provinceCode"
                    @change="handleProvinceChange"
                    clearable
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in provinceDatas"
                      :key="item.id"
                      :label="item.name"
                      :value="item.code"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item prop="cityCode">
                  <el-select
                    v-model="addForm.cityCode"
                    @change="handleCityChange"
                    clearable
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in cityDatas"
                      :key="item.id"
                      :label="item.name"
                      :value="item.code"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item prop="districtCode">
                  <el-select
                    v-model="addForm.districtCode"
                    @change="handleDistrictChange"
                    clearable
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in districtDatas"
                      :key="item.id"
                      :label="item.name"
                      :value="item.code"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-form-item>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="详细地址" prop="addressDetail">
                <el-input
                  v-model="addForm.addressDetail"
                  placeholder="请输入内容"
                  maxlength="40"
                  show-word-limit
                  auto-complete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="设备品类" prop="deviceCategoryIds">
                <el-select
                  v-model="addForm.deviceCategoryIds"
                  multiple
                  collapse-tags
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in deviceCategoryDatas"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="联系人" prop="contact">
                <el-input
                  v-model="addForm.contact"
                  placeholder="请输入内容"
                  maxlength="10"
                  show-word-limit
                  auto-complete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item label="联系电话" prop="telephone">
                <el-input
                  v-model="addForm.telephone"
                  placeholder="请输入内容"
                  maxlength="11"
                  show-word-limit
                  auto-complete="off"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="loading"
            >提交</el-button
          >
        </div>
      </el-dialog>

      <el-dialog
        title="编辑"
        :visible.sync="editFormVisible"
        @open="onEditDialogOpen"
        :close-on-click-modal="false"
      >
        <el-form
          :model="editForm"
          label-width="100px"
          :rules="formRules"
          ref="editForm"
        >
          <el-input v-model="editForm.id" type="hidden"></el-input>
          <el-row>
            <el-col :span="12">
              <el-form-item label="项目名称" prop="name">
                <el-input
                  v-model.trim="editForm.name"
                  placeholder="请输入内容"
                  maxlength="30"
                  show-word-limit
                  auto-complete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="客户名称" prop="orgId">
                <el-select
                  v-model="editForm.orgId"
                  filterable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in custDatas"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="2">
            <el-form-item label="省市区" required>
              <el-col :span="7">
                <el-form-item prop="provinceCode">
                  <el-select
                    v-model="editForm.provinceCode"
                    @change="handleProvinceChange"
                    clearable
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in provinceDatas"
                      :key="item.id"
                      :label="item.name"
                      :value="item.code"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item prop="cityCode">
                  <el-select
                    v-model="editForm.cityCode"
                    @change="handleCityChange"
                    clearable
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in cityDatas"
                      :key="item.id"
                      :label="item.name"
                      :value="item.code"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item prop="districtCode">
                  <el-select
                    v-model="editForm.districtCode"
                    @change="handleDistrictChange"
                    clearable
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in districtDatas"
                      :key="item.id"
                      :label="item.name"
                      :value="item.code"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-form-item>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="详细地址" prop="addressDetail">
                <el-input
                  v-model="editForm.addressDetail"
                  placeholder="请输入内容"
                  maxlength="40"
                  show-word-limit
                  auto-complete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="设备品类" prop="deviceCategoryIds">
                <el-select
                  v-model="editForm.deviceCategoryIds"
                  multiple
                  collapse-tags
                  @change="handleDeviceCategoryChange"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in deviceCategoryDatas"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="联系人" prop="contact">
                <el-input
                  v-model="editForm.contact"
                  placeholder="请输入内容"
                  maxlength="10"
                  show-word-limit
                  auto-complete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item label="联系电话" prop="telephone">
                <el-input
                  v-model="editForm.telephone"
                  placeholder="请输入内容"
                  maxlength="11"
                  show-word-limit
                  auto-complete="off"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button
            type="primary"
            @click.native="editSubmit"
            :loading="loading"
            >提交</el-button
          >
        </div>
      </el-dialog>
    </el-col>
  </el-row>
</template>
<script>
import ORG_API from "../../api/api_org";
import PROJECT_API from "../../api/api_project";
import REGION_API from "../../api/api_region";
import DEVICE_API from "../../api/api_device";

export default {
  data() {
    return {
      loading: false,
      filters: {},

      // 分页参数
      total: 0,
      page: 1,
      limit: 10,
      projectPageDatas: [],
      custDatas: [],
      provinceDatas: [],
      cityDatas: [],
      districtDatas: [],
      deviceCategoryDatas: [],

      // 新增/编辑相关数据
      addFormVisible: false, //新增界面是否显示
      editFormVisible: false, //编辑界面是否显示
      addForm: {},
      editForm: {},
      formRules: {
        name: [{ required: true, message: "请输入项目名称", trigger: "blur" }],
        orgId: [{ required: true, message: "请选择客户", trigger: "blur" }],
        provinceCode: [
          { required: true, message: "请选择省份", trigger: "blur" }
        ],
        cityCode: [{ required: true, message: "请选择城市", trigger: "blur" }],
        districtCode: [
          { required: true, message: "请选择区县", trigger: "blur" }
        ],
        addressDetail: [
          { required: true, message: "请输入详细地址", trigger: "blur" }
        ],
        deviceCategoryIds: [
          { required: true, message: "请选择设备品类", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.handleSearch();
    },
    search() {
      let that = this;
      let params = Object.assign(
        {
          page: that.page,
          limit: that.limit
        },
        that.filters
      );
      PROJECT_API.projectList(params)
        .then(
          function (result) {
            if (result && result.code == 200) {
              that.total = result.data.total;
              that.projectPageDatas = result.data.records;
            }
          },
          function (error) {
            that.$message.error({
              showClose: true,
              message: error.toString(),
              duration: 2000
            });
          }
        )
        .catch(function (error) {
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    handleSearch() {
      this.total = 0;
      this.page = 1;
      this.search();
    },
    handleSizeChange(val) {
      this.limit = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.search();
    },
    custList: function () {
      let that = this;
      let params = {};
      ORG_API.companyList(params)
        .then(
          function (result) {
            that.loading = false;
            if (result && result.code == 200) {
              that.custDatas = result.data;
            }
          },
          function (error) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: error.toString(),
              duration: 2000
            });
          }
        )
        .catch(function (error) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常!",
            duration: 2000
          });
        });
    },
    loadRegion: function (code, callback) {
      let that = this;
      REGION_API.childrens(code)
        .then(
          function (result) {
            if (result && result.code == 200) {
              if (typeof callback === "function") {
                callback(result.data);
              }
            }
          },
          function (error) {
            that.$message.error({
              showClose: true,
              message: error.toString(),
              duration: 2000
            });
          }
        )
        .catch(function (error) {
          that.$message.error({
            showClose: true,
            message: "请求出现异常!",
            duration: 2000
          });
        });
    },
    handleProvinceChange: function () {
      let that = this;
      let form = this.addFormVisible ? this.addForm : this.editForm;
      form.cityCode = "";
      form.districtCode = "";
      this.cityDatas = [];
      this.districtDatas = [];
      if (form.provinceCode === "") {
        return;
      }
      this.loadRegion(form.provinceCode, function (data) {
        that.cityDatas = data;
      });
    },
    handleCityChange: function () {
      let that = this;
      let form = this.addFormVisible ? this.addForm : this.editForm;
      form.districtCode = "";
      this.districtDatas = [];
      if (form.cityCode === "") {
        return;
      }
      this.loadRegion(form.cityCode, function (data) {
        that.districtDatas = data;
      });
    },
    handleDistrictChange: function () {
      this.$forceUpdate();
    },
    handleDeviceCategoryChange: function () {
      this.$forceUpdate();
    },
    deviceCategoryCombox: function () {
      let that = this;
      DEVICE_API.deviceCategoryCombox()
        .then(
          function (result) {
            if (result && result.code == 200) {
              that.deviceCategoryDatas = result.data;
            }
          },
          function (error) {
            that.$message.error({
              showClose: true,
              message: error.toString(),
              duration: 2000
            });
          }
        )
        .catch(function (error) {
          that.$message.error({
            showClose: true,
            message: "请求出现异常!",
            duration: 2000
          });
        });
    },
    projectDeviceCategoriesList: function (projectId) {
      let that = this;
      PROJECT_API.projectDeviceCategories(projectId)
        .then(
          function (result) {
            if (result && result.code == 200) {
              let deviceCategoryIds = [];
              for (var i = 0; i < result.data.length; i++) {
                deviceCategoryIds.push(result.data[i].deviceCategoryId);
              }
              that.editForm.deviceCategoryIds = deviceCategoryIds;
            }
          },
          function (error) {
            that.$message.error({
              showClose: true,
              message: error.toString(),
              duration: 2000
            });
          }
        )
        .catch(function (error) {
          that.$message.error({
            showClose: true,
            message: "请求出现异常!",
            duration: 2000
          });
        });
    },
    showAddDialog: function () {
      let that = this;
      this.addFormVisible = true;
      this.custList();
      this.loadRegion("000000", function (data) {
        that.provinceDatas = data;
      });
      this.deviceCategoryCombox();
    },
    onAddDialogOpen: function () {
      this.$nextTick(() => {
        this.$refs["addForm"].clearValidate();
      });
    },
    //新增
    addSubmit: function () {
      let that = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          that.loading = true;
          let params = Object.assign({}, this.addForm);
          PROJECT_API.save(params)
            .then(
              function (result) {
                that.loading = false;
                if (
                  result &&
                  result.code == 200 &&
                  result.data &&
                  result.data === true
                ) {
                  that.$message.success({
                    showClose: true,
                    message: "新增成功!",
                    duration: 2000
                  });
                  that.$refs["addForm"].resetFields();
                  that.addFormVisible = false;
                  that.handleSearch();
                } else {
                  that.$message.error({
                    showClose: true,
                    message: "新增失败!",
                    duration: 2000
                  });
                }
              },
              function (error) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: error.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function (error) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常!",
                duration: 2000
              });
            });
        }
      });
    },
    //显示编辑界面
    showEditDialog: function (index, row) {
      let that = this;
      this.editFormVisible = true;
      //避免源对象row被修改
      var newRow = JSON.parse(JSON.stringify(row));
      this.editForm = Object.assign({}, newRow);
      this.custList();
      this.loadRegion("000000", function (data) {
        that.provinceDatas = data;
      });
      this.loadRegion(this.editForm.provinceCode, function (data) {
        that.cityDatas = data;
      });
      this.loadRegion(this.editForm.cityCode, function (data) {
        that.districtDatas = data;
      });
      this.projectDeviceCategoriesList(this.editForm.id);
      this.deviceCategoryCombox();
    },
    onEditDialogOpen: function () {
      this.$nextTick(() => {
        this.$refs["editForm"].clearValidate();
      });
    },
    //编辑
    editSubmit: function () {
      let that = this;
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          that.loading = true;
          let params = Object.assign({}, this.editForm);
          PROJECT_API.update(params)
            .then(
              function (result) {
                that.loading = false;
                if (
                  result &&
                  result.code == 200 &&
                  result.data &&
                  result.data === true
                ) {
                  that.$message.success({
                    showClose: true,
                    message: "修改成功!",
                    duration: 2000
                  });
                  that.$refs["editForm"].resetFields();
                  that.editFormVisible = false;
                  that.handleSearch();
                } else {
                  that.$message.error({
                    showClose: true,
                    message: "修改失败!",
                    duration: 2000
                  });
                }
              },
              function (error) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: error.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function (error) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常!",
                duration: 2000
              });
            });
        }
      });
    },
    toDetail: function (row) {
      let that = this;
      PROJECT_API.projectDeviceCategories(row.id)
        .then(
          function (result) {
            if (result && result.code == 200) {
              that.deviceCategoryDatas = result.data;
              localStorage.setItem(
                "PROJECT_DEVICE_CATEGORIES",
                JSON.stringify(that.deviceCategoryDatas)
              );
              if (that.deviceCategoryDatas.length > 0) {
                let deviceCategory = that.deviceCategoryDatas[0];
                that.$router.push({
                  name: deviceCategory.template,
                  params: {
                    id: row.id,
                    deviceCategoryId: deviceCategory.deviceCategoryId
                  }
                });
              }
            }
          },
          function (error) {
            that.$message.error({
              showClose: true,
              message: error.toString(),
              duration: 2000
            });
          }
        )
        .catch(function (error) {
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    //删除
    remove: function (index, row) {
      let that = this;
      this.$confirm("确认删除该记录吗?", "提示", { type: "warning" })
        .then(() => {
          that.loading = true;
          PROJECT_API.remove(row.id)
            .then(
              function (result) {
                that.loading = false;
                if (
                  result &&
                  result.code === 200 &&
                  result.data &&
                  result.data === true
                ) {
                  that.$message.success({
                    showClose: true,
                    message: "删除成功",
                    duration: 1500
                  });
                  that.search();
                }
              },
              function (err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function (error) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        })
        .catch(() => {});
    }
  },
  mounted() {
    let that = this;
    let params = {};

    this.handleSearch();
  }
};
</script>



// WEBPACK FOOTER //
// projectList.vue?6a4b390f